import Help from "../Help";

export default function TutorHelp() {
    return(
        <>
        <Help/>
        </>
    )
}